import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IClient } from "../../Typings/Client";
import { SelectedClientState } from "../../Typings/StoreStates";
import { RootState } from "../Store";
import { useAppSelector } from "../Hooks/reduxHooks";

export const SelectedClientSlice = createSlice({
  name: "selectedClient",
  initialState: {
    value: {
      isLoading: true,
    },
  } as SelectedClientState,
  reducers: {
    updateClient: (state, action: PayloadAction<IClient>) => {
      state.value = action.payload;
    },
    removeClient: (state) => {
      state.value = {
        clientId: "",
        clientName: "",
        isLoading: false,
        hasAnalytics: false,
        hasCareers: false,
        hasCrm: true,
        sentEmailCount: 0,
        sentTextCount: 0,
        quotas: {
          emailQuota: 0,
          textQuota: 0,
        },
      };
    },
    toggleLoading: (state, action: PayloadAction<boolean>) => {
      state.value.isLoading = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateClient, removeClient, toggleLoading } = SelectedClientSlice.actions;

export const selectClientValue = (state: RootState) => state.selectedClient.value as IClient;

const selectCrmLiteClient = createSelector<[(state: RootState) => IClient], boolean>(
  [selectClientValue],
  (client) => client.hasCareers && !client.hasCrm,
);
export const useCrmLiteClient = () => useAppSelector(selectCrmLiteClient);

export default SelectedClientSlice.reducer;
